// Product.availability: 'Disponible' | 'No disponible' | 'Agotado'. Los dos
// últimos no se pueden pedir. Sin el campo, cuenta como disponible.
export const estaDisponible = (product) =>
  !product?.availability || product.availability === 'Disponible';
